import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FullPageInfoField } from '@components-clean/core/info-field';
import { IFormData, ProtocolReviewContext } from '@pages-clean/risk-assessment/risk-iq/interfaces/context';
import { NullableStudy } from '@contexts/local-state-context';
import { getIsActiveField } from '@utils/convertor';
import { LoggedInPageProps } from '@config/routes/interfaces';
import './index.scss';

interface IProtocolReviewHistoryProps {
    study: NullableStudy | undefined;
}

const Content = ({ study }: IProtocolReviewHistoryProps) => {
    const [formData, setFormData] = useState<IFormData>({
        study,
    });

    const StudyHasRAM = study && getIsActiveField('RAM', study.modules);

    const protocolReviewHistoryProviderValue = useMemo(
        () => ({
            current: formData,
            setCurrent: setFormData,
        }),
        [formData, setFormData],
    );

    const { t: tHome } = useTranslation('home');

    useEffect(() => {
        setFormData({
            ...formData,
            study,
        });
    }, [study?.id]);

    if (!StudyHasRAM)
        return <FullPageInfoField message={tHome('home:pageDataErrors:cannotAccessModule')} type="Info" />;

    return (
        <div className="protocolReviewHistory-container">
            <ProtocolReviewContext.Provider value={protocolReviewHistoryProviderValue}>
                <div style={{ height: 'calc(100% - 30px)' }}>HISTORY</div>
            </ProtocolReviewContext.Provider>
        </div>
    );
};

const ProtocolReviewHistoryWrapper = ({ study }: IProtocolReviewHistoryProps) => {
    const content = <Content study={study} />;

    return <>{content}</>;
};

const ProtocolReviewHistory = ({ study }: LoggedInPageProps) => <ProtocolReviewHistoryWrapper study={study} />;

export default ProtocolReviewHistory;
